import React from "react";

const Index = ({ activeTab, activeTrack }) => {
  const styles = {};

  if (activeTab === "lyrics") {
    styles.backgroundImage = `url(${activeTrack.lyricBackground})`;
  }

  return (
    <div
      className={`tab-body tab-body--${activeTab}`}
      style={styles}
      dangerouslySetInnerHTML={{ __html: activeTrack[activeTab] }}
    />
  );
};

export default Index;
